import React from "react";
import { Card } from 'tea-component';
import { useIntl } from 'umi';

export default function () {
  const {formatMessage} = useIntl();

  return (
    <Card className={"dbl-gpt-home-guid dbl-gpt-home-guid-notes"}>
      <Card.Body title={<div className={"dbl-title-16"}>{formatMessage({id: "dbl_gpt_home_tip_title"})}</div>}>
        <div className="dbl-gpt-notes-txt" dangerouslySetInnerHTML={{__html: formatMessage({id: "dbl_gpt_prompt_title"})}}>
        </div>
      </Card.Body>
    </Card>
  )
}
